module.exports = __webpack_public_path__ + "5c114213/img/grid-web-icon.d0395d64.svg";